var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#CFA967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01125 9.53156V14.0276L12.3564 13.1265L13.1423 4.46963H9.01125V8.14387L9.18225 7.61119H9.63L9.01125 9.53156ZM4.85775 13.7638L3.9375 3.65625H14.0625L13.1423 13.7638L8.98875 14.9062L4.85775 13.7638ZM7.76194 9.94275V9.52594L6.37313 8.97244L7.7625 8.41556V7.99819L5.77856 8.80425V9.13725L7.76194 9.94275ZM12.2242 9.13725L10.2403 9.94275V9.52594L11.6297 8.97075L10.2403 8.41556V7.99819L12.2242 8.80425V9.13725ZM9.01125 9.53156V8.14387L8.27044 10.4541H8.71369L9.01125 9.53156Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.f357229c637587fd55bd020538037801.svg";
export { ForwardRef as ReactComponent };